// 券资源位来源
export const couponFromConf = {
  banner: 0, // 券来自 banner
  falling: 1, // 券来自天降
}

// 券 banner 来源
export const bannerFromConf = {
  home: 'home', // 首页券 banner
  tickets: 'tickets', // 车次列表页券 banner
  makeOrder: 'makeOrder', // 下单页面
}

// 券状态配置
export const couponStatusConf = {
  unclaimed: {
    text: '立即领取',
    status: 0,
    color: '#f86316',
  },
  received: {
    text: '已领取',
    status: 1,
    color: '#f863164c',
  },
  locked: {
    text: '购票解锁',
    status: 2,
    color: '#f86316',
  },
  unlocked: {
    text: '已解锁',
    status: 3,
    color: '#f863164c',
  },
  noStock: {
    text: '已抢光',
    status: 4,
    color: '#f863164c',
  },
}
